import { useEffect } from "react";
import { SETTING_ACCESSIBILITY_CHANGED_EVENT } from "../events/accessibilityChanged.js";
import { CONTROL_VISIBILITY_CHANGED_EVENT } from "../events/visibilityChanged.js";
import { calculateControlBreadcrumb } from "../sidebar/calculateControlBreadcrumb.js";
import { CONDITIONAL_HIDDEN_CLASS_NAME } from "../sidebar/conditionalControls.js";
import { getSidebarCustomize } from "../sidebar/getSidebarCustomize.js";
/**
 * Dispatch a `SettingAccessibilityChangedEvent` when an accessibility value changes with
 * all relevant information. This is useful to calculate an accessibility-score.
 */ function useA11yDispatcher(param) {
    let { setting, valid } = param;
    useEffect(()=>{
        const customize = getSidebarCustomize();
        const dispatch = ()=>customize.control(setting, async (instance)=>{
                const { container } = instance;
                const visible = !container.hasClass(CONDITIONAL_HIDDEN_CLASS_NAME);
                const breadcrumb = await calculateControlBreadcrumb(setting);
                document.dispatchEvent(new CustomEvent(SETTING_ACCESSIBILITY_CHANGED_EVENT, {
                    detail: {
                        setting,
                        valid,
                        visible,
                        breadcrumb,
                        instance
                    }
                }));
            });
        dispatch();
        // Listen to visibility changes
        const listener = async (param)=>{
            let { detail: { setting: eSetting } } = param;
            if (setting === eSetting) {
                dispatch();
            }
        };
        document.addEventListener(CONTROL_VISIBILITY_CHANGED_EVENT, listener);
        return ()=>{
            document.removeEventListener(CONTROL_VISIBILITY_CHANGED_EVENT, listener);
        };
    }, [
        setting,
        valid
    ]);
}
export { useA11yDispatcher };
